import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const segmentGroupV2DefaultVariants = {
  "size": "sm"
}
const segmentGroupV2CompoundVariants = []

const segmentGroupV2SlotNames = [
  [
    "root",
    "segment-group-v2__root"
  ],
  [
    "label",
    "segment-group-v2__label"
  ],
  [
    "item",
    "segment-group-v2__item"
  ],
  [
    "itemText",
    "segment-group-v2__itemText"
  ],
  [
    "itemControl",
    "segment-group-v2__itemControl"
  ],
  [
    "indicator",
    "segment-group-v2__indicator"
  ]
]
const segmentGroupV2SlotFns = /* @__PURE__ */ segmentGroupV2SlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, segmentGroupV2DefaultVariants, getSlotCompoundVariant(segmentGroupV2CompoundVariants, slotName))])

const segmentGroupV2Fn = memo((props = {}) => {
  return Object.fromEntries(segmentGroupV2SlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const segmentGroupV2VariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...segmentGroupV2DefaultVariants, ...compact(variants) })

export const segmentGroupV2 = /* @__PURE__ */ Object.assign(segmentGroupV2Fn, {
  __recipe__: false,
  __name__: 'segmentGroupV2',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: segmentGroupV2VariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, segmentGroupV2VariantKeys)
  },
  getVariantProps
})